import type { IconSvgObject } from './types';

const TextVariableFrontIcon: IconSvgObject = [
  ["path", { d: "M7.5 15H4.5M6 3L6 15M2 4.5V4C2 3.44772 2.44772 3 3 3H9C9.55228 3 10 3.44772 10 4V4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 15H16.5M18 3L18 15M14 4.5V4C14 3.44772 14.4477 3 15 3H21C21.5523 3 22 3.44772 22 4V4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 19H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 19L22 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["circle", { cx: "12", cy: "19", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default TextVariableFrontIcon;
